import { render, staticRenderFns } from "./backtop.vue?vue&type=template&id=f9c1a874"
import script from "./backtop.vue?vue&type=script&lang=js"
export * from "./backtop.vue?vue&type=script&lang=js"
import style0 from "./backtop.vue?vue&type=style&index=0&id=f9c1a874&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports